import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import About from "@/components/About";
import CompareTree from "@/components/CompareTree";
import Guide from "@/components/Guide";
import cnGuide from "@/components/cnGuide";
import cnAbout from "@/components/cnAbout";
import Login from "@/components/Login";

Vue.use(Router)

export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/compareTree',
      name: 'compareTree',
      component: CompareTree
    },
    {
      path: '/guide',
      name: 'Guide',
      component: Guide
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/zh-cn/guide',
      name: 'cnGuide',
      component: cnGuide
    },
    {
      path: '/zh-cn/about',
      name: 'cnAbout',
      component: cnAbout
    },
  ]
})
